import { LocalStorageStateDto } from '@emutabakat-types/app';

export enum LocalStorageStates {
  appState = 'app.state',
  kullaniciState = 'kullanici.state',
  mutabakatState = 'mutabakat.state'
}

export const saveState = (stateKey: string, state: LocalStorageStateDto) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(stateKey, serializedState);
  } catch {
    // ignore write errors
  }
};

export const getPersistedState = (stateKey: string) => {
  const persistedState: string | null = localStorage.getItem(stateKey);
  return persistedState;
};
